import React from 'react'

const MessageAdmin = () => {
    return (
        <div className="baseocom-text-font baseocom-text-lg">
            <h2>Dans les réglages</h2>
            <div className="baseocom-flex baseocom-items-center baseocom-gap-2">
                <p className=" baseocom-m-0 baseocom-size-6 baseocom-flex-row-center baseocom-bg-purple baseocom-rounded-full baseocom-text-white">
                    1
                </p>
                <p className="baseocom-m-0">Choisissez un type de fiche</p>
            </div>
            <ul className="baseocom-m-0 baseocom-ml-10 baseocom-list-none">
                <li>- Particuliers</li>
                <li>- Professionnels</li>
            </ul>
            <div className="baseocom-flex baseocom-mt-5 baseocom-items-center baseocom-gap-2">
                <p className="baseocom-leading-none baseocom-m-0 baseocom-size-6 baseocom-flex-row-center baseocom-bg-purple baseocom-rounded-full baseocom-text-white">
                    2
                </p>
                <p className="baseocom-m-0">Effectuer une recherche d'un document</p>
            </div>
        </div>
    )
}

export default MessageAdmin
